import {AfterViewInit, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {CoreConfigService} from '@core/services/config.service';
import {Store} from '@ngrx/store';
import {AuthHelperService} from 'app/auth/helpers/auth-helper.service';
import {RouterService} from 'app/global/router.service';
import {login, setIframeState} from 'app/store/actions/auth.action';
import {AuthFacade} from 'app/store/auth.facade';
import {Subject, Subscription} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {CoreConfig} from '../../@core/types';
import { ActivatedRoute } from '@angular/router';


export enum CrmType {
    Hubspot = "hubspot",
    Pipedrive = "pipedrive",
    IFrameAble = "iframeable"
}

@Component({
  selector: 'app-crm-login',
  templateUrl: './crm-login.component.html',
  styleUrls: ['./crm-login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CrmLoginComponent implements OnInit, AfterViewInit, OnDestroy {
  // Public
  public coreConfig: CoreConfig;
  public loginForm: UntypedFormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  public passwordTextType: boolean;

  // Private
  private _unsubscribeAll: Subject<void>;
  private timeOutSubscription: Subscription;
  public authFormLoader$ = this._authFacade.authFormLoader$;
  public loginVia: string = '';
  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   * @param {UntypedFormBuilder} _formBuilder
   * @param {Store} store
   * @param {AuthHelperService} authHelper
   * @param _authFacade
   * @param _routerService
   */
  constructor(
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private store: Store,
    private authHelper: AuthHelperService,
    private _authFacade: AuthFacade,
    private _routerService: RouterService,
    private route: ActivatedRoute,
  ) {
    this._unsubscribeAll = new Subject<void>();
    this.authHelper.setLayoutConfig(true, false, true);
  }

  // convenience getter for easy access to form fields
  get form() {
    return this.loginForm.controls;
  }

  /**
   * Toggle password
   */
  togglePasswordTextType() {
    this.passwordTextType = !this.passwordTextType;
  }




  /** Handle Login Form Submittion */
  onLogin() {
    const isIFrameAble = this.loginVia === CrmType.IFrameAble ? true : false;
    if (this.loginForm.invalid) {
      return;
    }
    if(isIFrameAble){
      this.store.dispatch(setIframeState(true));
    }
    this.store.dispatch(login({ credentials: this.loginForm.value, end_user: true, isThirdPartyLogin: !isIFrameAble }));
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.loginVia = this.route.snapshot.data['loginVia'];
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
      login_via: this.loginVia === CrmType.IFrameAble ? CrmType.IFrameAble : CrmType.Pipedrive,
    });

    // Subscribe to config changes
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
    
  }



  ngAfterViewInit(){
   this._routerService.setCrmParams();
  }



  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();

    if (this.timeOutSubscription) {
      this.timeOutSubscription.unsubscribe();
    }
  }
}
